export default "__VITE_PUBLIC_ASSET__e3741558__"